/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

export const Spinner = ({ label }: { label: string }) => {
  return (
    <div className="flex h-screen w-full items-center justify-center p-4">
      <div className="flex flex-col items-center justify-center">
        <div
          className="h-12 w-12 animate-spin rounded-full
          border-2 border-solid border-link-active border-t-transparent shadow-md"
        ></div>
        <div className="p-4">{label}</div>
      </div>
    </div>
  );
};
